import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';

import { categories } from '@sorare/gameplay/src/pages/MissionsPageLayout/MissionsCategorySelector';

const MLBMissionsCategoryTabsLayout = ({ children }: PropsWithChildren) => {
  const { sport } = useSportContext();
  return (
    <ContentWithStickyHeader
      header={
        <FullWidthContainer.NoPadding>
          <TabBar variant="flat" fullWidth>
            {categories(sport).map(({ link, title }) => (
              <Tab key={link} to={link}>
                {title}
              </Tab>
            ))}
          </TabBar>
        </FullWidthContainer.NoPadding>
      }
    >
      {children}
    </ContentWithStickyHeader>
  );
};

const MLBMissionsCategoryLayout = () => {
  const isDesktopAndAbove = useIsDesktopAndAbove();

  return (
    <ConditionalWrapper
      Wrapper={MLBMissionsCategoryTabsLayout}
      wrap={!isDesktopAndAbove}
    >
      <Outlet />
    </ConditionalWrapper>
  );
};

export default MLBMissionsCategoryLayout;
